import VueCharts from "vue-chartjs";
import { Bar, Radar } from "vue-chartjs";

export default {
    extends: Radar,
    props: {
        labels: {
            type: Array,
            default: [],

        },
        datasets: {
            type: Array,
            default: [],
        }
    },

    mounted() {
        this.renderChart(
            {
                labels: this.labels,
                datasets: this.datasets,
            },
            {
                title: {
                    display: false,
                    text: "",
                },
                legend: {
                    display: false,
                },
                scale: {
                    ticks: {
                        beginAtZero: true,
                        // max: 20,
                        min: 0,
                        stepSize: 5
                    },
                    pointLabels: {
                        fontSize: 14
                    }

                },



                responsive: true,
                maintainAspectRatio: false,
            }
        );
    },
};
